module.exports = __webpack_public_path__ + "img/title1.ac1a845e.png";